// NodeColorField.jsx

import React from 'react';

// CSS
import './NodeColorField.css';

// Components
import ColorButton from 'components/colorbutton/ColorButton';

/**
 * NodeColorField
 *
 * Displays the built-in node identity color picker as an inline swatch row.
 *
 * @param {string|null} value - Current root node color value.
 * @param {function} onChange - Called with the next color value.
 *
 * @returns {ReactNode} The rendered color field.
 */
const NodeColorField = ({ value, onChange, readOnly = false }) => {
    const normalizedValue = typeof value === 'string' ? value.trim() : '';

    return (
        <div className="node-color-field-container">
            <ColorButton
              variant="inline"
              color={normalizedValue}
              disabled={readOnly}
              onChange={readOnly ? undefined : ((nextColor) => onChange?.(nextColor || null))}
            />
        </div>
    );
};

NodeColorField.displayName = 'NodeColorField';

export default NodeColorField;
